export default import.meta.ROLLUP_FILE_URL_C3JYjjT3;